var React = require('react');

function IconContactMail (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#8E8E8E","d":"M741.832 122.645H57.746c-26.989 0-48.863 21.875-48.863 48.863V627.55c0 26.988 21.875 48.863 48.863 48.863h684.086c26.988 0 48.863-21.875 48.863-48.863V171.508c0-26.988-21.875-48.863-48.863-48.863zm-10.423 32.573L399.789 411.59 68.168 155.218h663.241zM41.446 620.875V175.743l251.01 193.988-251.01 251.144zm22.976 22.976l253.94-253.92 71.321 55.2a16.277 16.277 0 0019.869 0l71.661-55.2 253.94 253.92H64.422zm693.71-22.976L507.121 369.731l251.011-193.988v445.132z"}));
}

IconContactMail.defaultProps = {"viewBox":"0 0 800 800"};

module.exports = IconContactMail;

IconContactMail.default = IconContactMail;
